<template>
<div style="background-color: #ffffffd9">
  <div class="backgimg"></div>
	<div class="container">
    <div class="row">
      <div class="col-12 col-md-2 mb-4 mb-md-0 py-4" data-aos="fade-up">
        <div
          class="sidebar d-flex flex-column theme-border-radius theme-bg-white theme-box-shadow sticky"
        >
          <a
            href="/about-us"
            class="border-bottom p-3 theme-text-accent-one"
            >About us</a
          ><a href="/contact-us" class="border-bottom p-3 theme-text-accent-one"
            >Contact us</a
          ><a href="/privacy-policy" class="border-bottom p-3 theme-text-accent-one"
            >Privacy Policy</a
          >
          <a href="/terms-conditions" class="border-bottom p-3 theme-text-accent-one"
            >Terms of use</a
          >
        </div>
      </div>
      <div
        class="col-12 col-md-10 aboutContent py-4"
        v-html="aboutContent"
      ></div>
    </div>
	</div>
  </div>
  <!-- <div class="p-3" style="background-color:#ffffffd9">
    <section class="aboutContent" v-html="aboutContent"></section>
  </div> -->
</template>

<script>
import axios from "axios";
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";

export default {
  data() {
    return {
      aboutContent: "",
      getAboutUrl: "",
      aboutType: "",
      getLangname: "",
      preventData: false,
    };
  },

  methods: {
    async getConfig() {
      const locale = this.getLangname;
      const getConfigData = getConfigDataFromLocalStorage();

      if (getConfigData) {
        const siteContentData = getConfigData.payload.portal_configuration.site_content_data;

        if (siteContentData && siteContentData[locale]) {
          console.log(locale,siteContentData,this.getLangname,'siteContentData')
          this.getAboutUrl = siteContentData[locale].aboutus.url;
          this.aboutType = siteContentData[locale].aboutus.type;

        //   console.log(`Using language: ${locale}`, "About URL:", this.getAboutUrl);

          await this.getConfigFunc();
        } else {
          console.error(`No aboutus data found for locale:`);
        }
      }
    },

    async getConfigFunc() {
      try {
        const response = await axios.get(this.getAboutUrl, {
          headers: {
            "Content-Type": this.aboutType,
          },
        });

        const cleanedResponse = response.data.replace(/text-center/g, "");
        this.aboutContent = cleanedResponse;
        // console.log("Fetched about content:", response.data);
      } catch (error) {
        console.error("Error fetching about content:", error);
      }
    },

    updateContent() {
       this.getLangname = this.$i18n.locale;
       this.getConfig();

      // const routeLang = this.$route.query.lang || currentLocale;

      // if (this.getLangname !== routeLang) {
      //   this.getLangname = routeLang;
      //   console.log("Updated language:", this.getLangname);
      //   this.getConfig();
      // }
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.updateContent();
      },
    },
  },

  // mounted() {
  //   this.updateContent();
  // },
created(){
    this.updateContent();
}
};
</script>
<style scoped>
@media screen and (max-width:480px) {
  :deep(.footr-content-wrap p){
    text-align:justify;
  }
}
:deep(.aboutContent){
  text-align:justify;
}
:deep(.aboutContent .text-center){
  text-align:start !important;
}
:deep(.aboutContent ul){
  list-style:disc !important;
  padding-left:2rem !important;
}
:deep(.aboutContent h4){
  font-size:22px !important;
  margin:22px 0px 10px !important;
}
:deep(.aboutContent h1){
  font-size:34px !important;
}
:deep(.aboutContent h2){
  font-size:30px !important;
}
:deep(.aboutContent p){
  margin-bottom:1rem !important;
  margin-top:1rem !important;
}
.sticky {
    position: sticky;
    top: 15%;
    background-color: #fff !important;
}
.theme-box-shadow {
    box-shadow: 0 0 .8rem rgba(52, 53, 52, .15);
}
.theme-border-radius, .theme-border-radius-top {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
}
.border-bottom {
    border-bottom: 1px solid #dee2e6 !important;
}
.theme-text-accent-one {
    color: #343534;
}
a{
	text-decoration:none;
}
.backgimg{
  /* background-image: url(https://www.columbiathreadneedle.com/uploads/2022/07/7261494b4139321e43bea28c6616b256/jumbo-jet-taking-off.jpg); */
  background-image: url(../assets/images/footer-4.jpg);

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 350px;
  width: 100%;
}
</style>